import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ChevronLeft, Mail, HelpCircle } from "lucide-react";

export default function Contact() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white">
      {/* Header */}
      <div className="p-4 border-b border-gray-700">
        <div className="flex items-center space-x-4">
          <Link to="/boards">
            <Button 
              variant="ghost" 
              size="sm"
              className="text-gray-300 hover:text-white"
            >
              <ChevronLeft className="h-4 w-4 mr-2" />
              Back to My DoDue Space
            </Button>
          </Link>
          <h1 className="text-xl font-semibold">Contact Us</h1>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-2xl mx-auto mt-12 p-6">
        <div className="bg-slate-800 rounded-lg p-8 shadow-lg">
          <h2 className="text-2xl font-bold mb-6">Get in Touch</h2>
          
          <div className="space-y-6">
            <div className="flex items-center space-x-4">
              <Mail className="h-6 w-6 text-blue-400" />
              <div>
                <h3 className="font-semibold">Email Us</h3>
                <a 
                  href="mailto:support@doduelife.com" 
                  className="text-blue-400 hover:text-blue-300"
                >
                  support@doduelife.com
                </a>
              </div>
            </div>

            <div className="flex items-center space-x-4">
              <HelpCircle className="h-6 w-6 text-green-400" />
              <div>
                <h3 className="font-semibold">FAQ</h3>
                <Link 
                  to="/faq"
                  className="text-green-400 hover:text-green-300"
                >
                  Visit DoDueLife Help Section
                </Link>
              </div>
            </div>
          </div>

          <div className="mt-8 p-4 bg-slate-700 rounded-lg">
            <p className="text-gray-300">
              We're here to help! Feel free to reach out with any questions, 
              feedback, or support needs. We typically respond within 24 hours.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
